import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download/6988256b921dc900142cd459/website_project/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6988256b921dc900142cd459/website_project/src/app/for-facilities/components/ForFacilitiesClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6988256b921dc900142cd459/website_project/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/6988256b921dc900142cd459/website_project/src/components/ui/AppIcon.tsx");
